import type { ReactElement } from "react";
import AlteSurse from "./pagini/AlteSurse";
import BilanturiMf from "./pagini/BilanturiMf";
import ContribuabiliAnaf from "./pagini/ContribuabiliAnaf";
import FirmeOnrc from "./pagini/FirmeOnrc";
import ListeNeoficiale from "./pagini/ListeNeoficiale";
import ListeOficiale from "./pagini/ListeOficiale";
import Nomenclatoare from "./pagini/Nomenclatoare";

// Cheile trebuie sa corespunda exact id-urilor paginilor GRUP_ACTUALIZARE_DATE din
// src/config/administrare.ts (verificat de un test — vezi rutePagini.test.ts).
export const PAGINI_ACTUALIZARE_DATE: Record<string, ReactElement> = {
  "firme-onrc": <FirmeOnrc />,
  "contribuabili-anaf": <ContribuabiliAnaf />,
  "bilanturi-mf": <BilanturiMf />,
  "liste-oficiale": <ListeOficiale />,
  "liste-neoficiale": <ListeNeoficiale />,
  nomenclatoare: <Nomenclatoare />,
  "alte-surse": <AlteSurse />,
};
